import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { CommercialStructureInsertService } from '../../service/commercial-structure-insert/commercial-structure-insert.service';

@Component({
	selector: 'app-commercial-structure-insert',
	templateUrl: './commercial-structure-insert.component.html',
	providers: [
		CommercialStructureInsertService,
		HttpModule
	]

})
export class CommercialStructureInsertComponent implements OnInit {
	private token;
	commercialStructure: FormGroup;
	public managers: any[] = [];
	public managersChecked: any[] = [];
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private commercialStructureInsertService: CommercialStructureInsertService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.commercialStructure = fb.group({
			'Nome': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': '',
			'Gerente': this.managersChecked[0]
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.commercialStructureInsertService.listManagers(this.token).subscribe(result => {
			this.managers = result.Result;
			this.managersChecked = [];
		}, error => {
			console.log(error);
			
		})
	}

	insertCommercialStructure(value: any) {

		var data = {
			Nome: value.Nome,
			Ativo: value.Ativo,
			Gerentes: []
		};

		var ListManagers = this.managers.filter(opt => opt.checked).map(opt => opt.CodigoSap);
		for (let obj of ListManagers) {
			data.Gerentes.push({ CodigoSap: obj.toString(), Ativo: true })
		}

		this.commercialStructureInsertService.insertCommercialStructure(this.token, data).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Diretoria cadastrada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/estrutura-comercial');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});

	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/estrutura-comercial');
	}

}




// WEBPACK FOOTER //
// ./src/app/commercial-structure/component/commercial-structure-insert/commercial-structure-insert.component.ts